import { apiGet, apiPost, apiPatch, apiDelete } from './client.js';

export function listProjects(limit = 50, offset = 0) { return apiGet(`/api/projects?limit=${limit}&offset=${offset}`); }
export function getProject(id) { return apiGet(`/api/projects/${id}`); }
export function createProject(name) { return apiPost('/api/projects', { name }); }
export function updateProject(id, data) { return apiPatch(`/api/projects/${id}`, data); }
export function deleteProject(id) { return apiDelete(`/api/projects/${id}`); }
